import { gql } from '@apollo/client';

export const REQUEST_VAT_RECEIPT = gql`
  mutation requestVatReceipt($quoteId: String!) {
    requestVatReceipt(quoteId: $quoteId) {
      complete
    }
  }
`;
